import { ControlInterface } from 'edocatbase/Form';

const ReactSelect = window.Edocat.Components.Select.default;
const { TextField } = window.Edocat.Components;
import { fetchDataBox } from '../../actions/form';
import { is } from 'ramda';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { getValue } from '../../lib/asyncvalue';

interface DataBoxInterface extends ControlInterface, ReduxComponentInterface {
	dbid: string;
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
}

class DataBox extends window.React.PureComponent<DataBoxInterface> {
	componentDidMount() {
		const {
			actions,
			name,
			control: { params },
			value,
			dbid,
			formInstanceId,
			innerFormInstanceId,
		} = this.props;

		if (value && (is(String, value) || !value?.label)) {
			actions.fetchDataBox(
				formInstanceId,
				params,
				dbid,
				name,
				value.value ? value.value : value,
				true,
				innerFormInstanceId
			);
		}
	}

	componentDidUpdate(prevProps) {
		const { value, dbid, name, onChange } = this.props;
		if (prevProps.dbid !== dbid && dbid === (value?.value || value)) {
			onChange([name], null, true);
		}
	}

	onSelectChange = (value: any) => {
		const { name, onChange } = this.props;
		onChange([name], value, true);
	};

	onAsyncChange = (event: any) => {
		const {
			actions,
			name,
			control: { params },
			dbid,
			formInstanceId,
			innerFormInstanceId,
		} = this.props;

		const value = event.target.value;

		if (value && value.length > 2) {
			actions.fetchDataBox(formInstanceId, params, dbid, name, value, false, innerFormInstanceId);
		}
	};

	render() {
		const {
			autoFocus,
			disabled,
			label,
			value,
			options,
			repeating,
			control: { params },
			mandatory,
			className,
			name,
			error,
			placeholder,
			dbid,
			readOnly,
			helperText,
			important,
		} = this.props;

		if (params && params.display === 'hidden') {
			return null;
		}

		const filteredOptions = Array.isArray(options) ? options.filter(item => item.value !== dbid) : options;

		return (
			<div className={`form-row row-${name}`}>
				{readOnly ? (
					<TextField
						className={className}
						id={name}
						label={label}
						name={name}
						value={getValue(value)}
						readOnly={true}
					/>
				) : (
					<ReactSelect
						autoFocus={autoFocus}
						className={className}
						label={label}
						error={error}
						disabled={disabled || !Boolean(dbid)}
						isClearable={!mandatory}
						multi={repeating}
						name={name}
						onChange={this.onSelectChange}
						onInputChange={this.onAsyncChange}
						options={filteredOptions}
						value={value}
						placeholder={placeholder}
						mandatory={mandatory}
						helperText={helperText}
						important={important}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state: any, props: any) => {
	const field = state[props.formInstanceId].form.fields[props.name];
	const dbidField = field.control?.params?.dbidField;
	let dbid = dbidField ? state[props.formInstanceId].form.fields[dbidField].value : null;
	if (!is(String, dbid)) {
		dbid = dbid?.value;
	}

	return { dbid };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ fetchDataBox }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(DataBox);
